import { get, filter } from 'lodash';
import { createSelector } from 'reselect';
import {
  makeOptionsData,
  makeOptionsDataWithEmpty,
  makeOptionsDataRemoveEmpty,
  makeOptionsDataWithAll,
} from 'Common/FormHelper';

const root = state => get(state, 'CommonState.filters');

export const getAcctCategoryDataLoading = state =>
  get(root(state), 'acctCategoryDataLoading', false);
export const getItemGroupDataLoading = state =>
  get(root(state), 'itemGroupDataLoading', false);
export const getVendorDataLoading = state =>
  get(root(state), 'vendorDataLoading', false);
export const getStorageLocationDataLoading = state =>
  get(root(state), 'storageLocationDataLoading', false);
export const getBidGroupDataLoading = state =>
  get(root(state), 'bidGroupDataLoading', false);
export const getSiteGroupDataLoading = state =>
  get(root(state), 'siteGroupDataLoading');

export const getBidGroupData = state => get(root(state), 'bidGroupData', []);
export const getItemGroupData = state => get(root(state), 'itemGroupData', []);
export const getAcctCategoryData = state =>
  get(root(state), 'acctCategoryData', []);
export const getVendorData = state => get(root(state), 'vendorData', []);
export const getStorageLocationData = state =>
  get(root(state), 'storageLocationData', []);
export const getSiteGroupData = state => get(root(state), 'siteGroupData');

export const getBidGroupDataError = state =>
  get(root(state), 'bidGroupDataError', null);
export const getItemGroupDataError = state =>
  get(root(state), 'itemGroupDataError', null);
export const getAcctCategoryDataError = state =>
  get(root(state), 'acctCategoryDataError', null);
export const getVendorDataError = state =>
  get(root(state), 'vendorDataError', null);
export const getStorageLocationDataError = state =>
  get(root(state), 'storageLocationDataError', null);
export const getSiteGroupDataError = state =>
  get(root(state), 'siteGroupLoadingError');

//reselect functions
export const selectBidGroupData = createSelector(
  getBidGroupData,
  bidGroupData => {
    return makeOptionsData(bidGroupData);
  }
);
export const selectItemGroupData = createSelector(
  getItemGroupData,
  itemGroupData => {
    return makeOptionsData(itemGroupData);
  }
);

export const selectAcctCategoryData = createSelector(
  getAcctCategoryData,
  acctCategoryData => {
    return makeOptionsData(acctCategoryData);
  }
);
export const selectAcctCategoryOptions = createSelector(
  getAcctCategoryData,
  acctCategoryData => {
    return makeOptionsDataRemoveEmpty(acctCategoryData);
  }
);

export const selectVendorData = createSelector(getVendorData, vendorData => {
  return makeOptionsData(vendorData);
});
export const selectVendorOptions = createSelector(getVendorData, vendorData => {
  return makeOptionsDataWithEmpty(vendorData);
});

export const selectStorageLocationData = createSelector(
  getStorageLocationData,
  storageLocationData => {
    return makeOptionsData(storageLocationData);
  }
);

export const selectStorageLocationDataRemoveEmpty = createSelector(
  getStorageLocationData,
  storageLocationData => {
    return makeOptionsDataRemoveEmpty(storageLocationData);
  }
);

export const getVendorDataWithEmpty = createSelector(
  getVendorData,
  vendorData => {
    return makeOptionsDataWithEmpty(vendorData);
  }
);

export const getStorageLocationDataWithEmpty = createSelector(
  getStorageLocationData,
  storageLocationData => {
    return makeOptionsDataWithEmpty(storageLocationData);
  }
);

export const getSiteGroupDataWithAll = createSelector(
  getSiteGroupData,
  siteGroups => {
    return makeOptionsDataWithAll(siteGroups);
  }
);
export const getVendorTableData = createSelector(getVendorData, vendorData => {
  return vendorData.length > 1
    ? filter(vendorData, vendor => vendor.Id !== 0)
    : [];
});



// WEBPACK FOOTER //
// ./src/state/filters/selectors.js